import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from '../Icon';
import Heart from '../../svg/icons/heart_lists.svg';
import { getPageContext } from '../../utils';
import { HOMEPAGE, VENUE_PAGE } from '../../utils/getPageContext';

import './IconHeart.scss';

const IconHeart = (props) => {
  const pageContext = getPageContext(window.location.pathname);
  const isVenuePage = pageContext === VENUE_PAGE;
  const isHomepage = pageContext === HOMEPAGE;
  const isSearchPage = !isVenuePage && !isHomepage;

  const {
    height, isLeaderboard, on, width,
  } = props;

  return (
    <div className={cx('IconHeart', {
      'IconHeart--on': on && (isSearchPage || isLeaderboard),
      'IconHeart--off': !on && (isSearchPage || isLeaderboard),
      'IconHeart--on--homepage': on && (isHomepage && !isLeaderboard),
      'IconHeart--off--homepage': !on && (isHomepage && !isLeaderboard),
      'IconHeart--on--venue-page': on && isVenuePage,
      'IconHeart--off--venue-page': !on && isVenuePage,
    })}
    >
      <Icon
        name="heart"
        component={Heart}
        height={height}
        width={width}
      />
    </div>
  );
};

IconHeart.propTypes = {
  height: PropTypes.string,
  isLeaderboard: PropTypes.bool,
  on: PropTypes.bool,
  width: PropTypes.string,
};

IconHeart.defaultProps = {
  height: '20px',
  isLeaderboard: false,
  on: false,
  width: '20px',
};

IconHeart.displayName = 'IconHeart';
export default IconHeart;
